export var STATE_MAP = {
  complete: 0,
  loading: 1,
  error: 2
};